export enum UserRole {
  Admin = 1,
  TeamOwner,
  Referee,
}

export const getRoleLabel = (role: UserRole) => {
  switch (role) {
    case UserRole.Admin:
      return 'Administrator';
    case UserRole.TeamOwner:
      return 'Właściciel drużyny';
    case UserRole.Referee:
      return 'Sędzia';

    default:
      return 'Brak';
  }
};

export interface ApiKeyData {
  creationDate: string; // unix timestamp in seconds
  validFor: string; // number of seconds
  userRole: UserRole;
  userName: string;
  userId: number;
}

export const getApiKeyData = (apiKey: string): ApiKeyData | undefined => {
  try {
    const data: {
      CreationDate: string;
      ValidFor: string;
      UserRole: UserRole;
      UserName: string;
      UserId: number;
    } = JSON.parse(atob(apiKey));
    return {
      creationDate: data.CreationDate,
      validFor: data.ValidFor,
      userRole: data.UserRole,
      userName: data.UserName,
      userId: data.UserId,
    };
  } catch (error) {
    console.error('Invalid apiKey retrieved, error: ' + error);
    return undefined;
  }
};

export const isAdminRole = (data?: ApiKeyData): boolean => {
  return data !== undefined && data.userRole === UserRole.Admin;
};

export const isRefereeRole = (data?: ApiKeyData): boolean => {
  return data !== undefined && data.userRole === UserRole.Referee;
};
